// src/utils/priceUtils.ts

import { useMemo } from 'react'
import { useDiscountPercent } from 'src/sdk/product/useDiscountPercent'

export interface PriceInfo {
  hasDiscount: boolean
  discountPercent?: string
  formattedListPrice?: string
  formattedPrice?: string
}

export function usePriceInfo(
  listPrice?: number,
  price?: number
): PriceInfo {
  const hasDiscount = !!listPrice && !!price && price < listPrice

  const rawPercent = hasDiscount
    ? useDiscountPercent(listPrice!, price!)
    : undefined

  const discountPercent = useMemo(() => {
    if (!rawPercent) return undefined
    return rawPercent.replace(/\..*$/, '')
  }, [rawPercent])

  const formattedListPrice = listPrice != null
    ? listPrice.toFixed(2).replace('.', ',')
    : undefined

  const formattedPrice = price != null
    ? price.toFixed(2).replace('.', ',')
    : undefined

  return {
    hasDiscount,
    discountPercent,
    formattedListPrice,
    formattedPrice,
  }
}
